import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Col,
  Container,
  Card,
  CardBody,
  ButtonToolbar,
  Button,
} from 'reactstrap';
import OrganizationChart from '@dabeng/react-orgchart';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from 'material-ui/styles';
import { LEVEL, INDIVIDUAL, SEND_TIMELINE } from '../../shared/utils/constants';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import OrgChartNode from './components/OrgChartNode';
import SmartItem from './components/SmartItem';
import GraphQl from '../../GraphQL';
import SideBar from './components/SideBar';
import {
  itensTabletListByNivel,
  saveTabletItemsMutation,
  maxNivelItemForNivel1,
  itensTabletByNivel1,
  itemTabletById,
} from '../../shared/queries/ItemsTablet';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';

const TabletItems = (props) => {
  const { t, dispatch } = props;
  const [selectedDtoOrgChart, setSelectedDtoOrgChart] = useState({});
  const [selectedDto, setSelectedDto] = useState({});
  const [isOpenSide, setIsOpenSide] = useState(false);
  const [orgTab, setOrgTab] = useState(false);
  const [effect, setEffect] = useState(false);
  const [data, setData] = useState([]);
  const [fatherId, setFatherId] = useState();
  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleSideBar = () => {
    setIsOpenSide(!isOpenSide);
  };

  const toggleOrgTab = () => {
    if (isOpenSide) {
      toggleSideBar();
    }
    setOrgTab(!orgTab);
  };

  const scroller = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const buildValueAndLabelField = (value) => {
    return value && !RegExp('null').test(value)
      ? {
          value,
          label: t(`mnt_tablet-items.label.${value}`),
        }
      : null;
  };

  const loadEditItem = async (id) => {
    const query = itemTabletById(id);
    showLoading();
    await GraphQl(query, {})
      .then((res) => {
        res.itemTabletById = [res.itemTabletById].map((item) => {
          let dto = { ...item };
          if (item.foodItem) {
            dto = {
              ...dto,
              typeOfMeal: item.typeOfMeal
                ? {
                    value: item.typeOfMeal,
                    label: t(`${item.typeOfMeal.name}`),
                  }
                : null,
            };
          } else {
            dto = {
              ...dto,
              typeOfMeal: '',
            };
          }
          if (item.needsApproval) {
            dto = {
              ...dto,
              approverProfile: buildValueAndLabelField(item.approverProfile),
            };
          } else {
            dto = {
              ...dto,
              approverProfile: '',
            };
          }
          if (item.requestTime) {
            dto = {
              ...dto,
              requestTimeType: buildValueAndLabelField(item.requestTimeType),
            };
          } else {
            dto = {
              ...dto,
              requestTimeType: '',
            };
          }
          dto = {
            ...dto,
            multiple: buildValueAndLabelField(item.multiple),
            sendTimeline: buildValueAndLabelField(item.sendTimeline),
            order: item.order.toString(),
          };
          return dto;
        });
        setSelectedDto(res.itemTabletById[0]);
        hideLoading();
        if (!isOpenSide) {
          toggleSideBar();
        }
        setEffect(!effect);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const editItemHandlerClick = (value) => {
    scroller();
    loadEditItem(value);
  };

  const changeFatherId = (value) => {
    setFatherId(value);
  };

  const addItemHandlerClick = (nodeData) => {
    const { id, level, program } = nodeData;
    if (!isOpenSide) {
      toggleSideBar();
    }
    scroller();
    const updatedDto = {
      id: 0,
      active: true,
      iconTablet: {},
      iconTimeline: {},
      multiple: {
        value: INDIVIDUAL,
        label: t('mnt_tablet-items.label.INDI'),
      },
      sendTimeline: {
        value: SEND_TIMELINE.NO,
        label: t('mnt_tablet-items.label.N'),
      },
      fatherCode: id,
      level,
      addOn: false,
      foodItem: false,
      needsApproval: false,
      timelineTime: false,
      requestTime: false,
      calculatePeriod: false,
      formItem: false,
      notConform: false,
      itemValue: '0',
      program,
      description: null,
    };
    setSelectedDto(updatedDto);
  };

  const loadOrgChart = (father, maxNivel) => {
    const query = itensTabletByNivel1(father, maxNivel);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        setSelectedDtoOrgChart(res.itensTabletByNivel1);
        hideLoading();
        if (!orgTab) {
          toggleOrgTab();
        }
        if (isOpenSide) {
          toggleSideBar();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadMaxNivelItemForNivel1 = (father) => {
    changeFatherId(father);
    const query = maxNivelItemForNivel1(father);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        loadOrgChart(father, res.maxNivelItemForNivel1 - LEVEL.ONE);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadItensTabletListByNivel = () => {
    const query = itensTabletListByNivel();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.itensTabletListByNivel = res.itensTabletListByNivel.map((item) => ({
          ...item,
        }));
        setData(res.itensTabletListByNivel);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = (values) => {
    const mutation = saveTabletItemsMutation(values);
    showLoading();
    GraphQl(mutation, {
      description: `${
        values.sendTimeline.value !== SEND_TIMELINE.NO ? values.description : ''
      }`,
    })
      .then(() => {
        hideLoading();
        toggleSideBar();
        if (orgTab) {
          loadMaxNivelItemForNivel1(fatherId);
        } else {
          loadItensTabletListByNivel();
        }
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const backToItemsNivelOne = () => {
    loadItensTabletListByNivel();
    toggleOrgTab();
  };

  useEffect(() => {
    const updated = { ...selectedDto };
    setSelectedDto(updated);
  }, [effect]);

  useEffect(() => {
    loadItensTabletListByNivel();
  }, []);

  return (
    <MuiThemeProvider>
      <>
        <Container className="items-tablet">
          <Container className={isOpenSide ? 'smartgrig-container' : ''}>
            <Card>
              <CardBody>
                <div className="card__title">
                  <h5 className="bold-text">{t('panels.items-tablet')}</h5>
                </div>
                <Col>
                  <div className="tabs tabs--justify tabs--bordered-bottom overflow-hidden">
                    <div className="tabs__wrap">
                      {!orgTab ? (
                        <div className="item-tablet-list">
                          {data.map((value) => (
                            <SmartItem
                              key={value.id}
                              item={value}
                              editItemhandler={editItemHandlerClick}
                              navigationHandler={loadMaxNivelItemForNivel1}
                            />
                          ))}
                          <SmartItem
                            newItem
                            addItemHandler={addItemHandlerClick}
                          />
                        </div>
                      ) : (
                        <>
                          <OrganizationChart
                            datasource={selectedDtoOrgChart}
                            chartClass="myChart"
                            NodeTemplate={(nodeData) => (
                              <OrgChartNode
                                nodeData={{ ...nodeData }}
                                onClickNodeAdd={addItemHandlerClick}
                                onClickNodeEdit={editItemHandlerClick}
                              />
                            )}
                            zoom
                            pan
                          />
                          <ButtonToolbar className="form__button-toolbar flex-nowrap flex-grow-1">
                            <Button
                              color="primary"
                              onClick={backToItemsNivelOne}
                            >
                              {t('general.back')}
                            </Button>
                          </ButtonToolbar>
                        </>
                      )}
                    </div>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Container>
          <SideBar
            onSubmit={handleSubmit}
            toggle={toggleSideBar}
            isOpen={isOpenSide}
            dto={selectedDto}
          />
        </Container>
      </>
    </MuiThemeProvider>
  );
};

TabletItems.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(TabletItems)
);
